import React, { useState } from "react";
import { downloadCertificate } from "../../services/AssignmentService";
import { Award, Download } from "../icons";
import { Button } from "../ui";

/**
 * "Certificate" action for completed, assigned content.
 *
 * Owns its busy state and surfaces the server's own refusal message — the
 * backend re-verifies BOTH assignment and completion before issuing, so this
 * button never decides eligibility itself; it only offers the action where the
 * item is already marked complete.
 */
export const CertificateButton = ({
  contentType,
  contentId,
  title,
  variant = "compact",
  label,
}) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const handle = async () => {
    setBusy(true);
    setError("");
    const message = await downloadCertificate(contentType, contentId, title);
    setBusy(false);
    if (message) setError(message);
  };

  if (variant === "link") {
    return (
      <div>
        <button
          type="button"
          className="ds-link"
          onClick={handle}
          disabled={busy}
          style={{ color: "var(--award)" }}
        >
          <Download size={14} />
          {busy ? "Preparing…" : label || "Download certificate"}
        </button>
        {error && (
          <p className="ds-sub" style={{ color: "var(--danger-ink)" }}>
            {error}
          </p>
        )}
      </div>
    );
  }

  return (
    <Button
      variant="award"
      size="sm"
      icon={Award}
      onClick={handle}
      disabled={busy}
      title="Download your completion certificate"
    >
      {busy ? "Preparing…" : label || "Certificate"}
    </Button>
  );
};

export default CertificateButton;
